/* ACP V9 — theme.js
   Shared helpers (money, delivery dates) + small global behaviours.
   Intentionally no scroll-jacking, parallax or opacity-gated reveals:
   in TikTok / Instagram in-app browsers everything must be visible immediately. */
document.documentElement.classList.remove('no-js');

(function () {
  var A = window.ACP || {};

  /* ---------- money: mirrors Shopify's own format so JS prices == Liquid prices ---------- */
  function withDelimiters(cents, precision, thousands, decimal) {
    var n = (Number(cents) / 100).toFixed(precision);
    var parts = n.split('.');
    var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    return parts[1] ? whole + decimal + parts[1] : whole;
  }
  function formatMoney(cents, opts) {
    opts = opts || {};
    var format = A.moneyFormat || '{{amount}}';
    var m = format.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!m) return String(cents / 100);
    var key = m[1];
    var compact = opts.compact && Number(cents) % 100 === 0;
    var value;
    switch (key) {
      case 'amount_no_decimals': value = withDelimiters(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, compact ? 0 : 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_no_decimals_with_space_separator': value = withDelimiters(cents, 0, ' ', '.'); break;
      case 'amount_with_space_separator': value = withDelimiters(cents, compact ? 0 : 2, ' ', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, compact ? 0 : 2, "'", '.'); break;
      default: value = withDelimiters(cents, compact ? 0 : 2, ',', '.');
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  /* ---------- delivery window: 4–8 business days (Monday–Friday) ---------- */
  var SQ_DAY = ['e diel', 'e hënë', 'e martë', 'e mërkurë', 'e enjte', 'e premte', 'e shtunë'];
  var SQ_MON = ['jan', 'shk', 'mar', 'pri', 'maj', 'qer', 'kor', 'gus', 'sht', 'tet', 'nën', 'dhj'];
  function makeFormatter(lang, withWeekday) {
    var opts = withWeekday ? { weekday: 'short', day: 'numeric', month: 'short' } : { day: 'numeric', month: 'short' };
    var supported = false;
    try { supported = Intl.DateTimeFormat.supportedLocalesOf([lang]).length > 0; } catch (e) {}
    if (lang === 'sq' && !supported) {
      return { format: function (d) { return (withWeekday ? SQ_DAY[d.getDay()] + ', ' : '') + d.getDate() + ' ' + SQ_MON[d.getMonth()] + '.'; } };
    }
    try { return new Intl.DateTimeFormat(lang, opts); } catch (e) { return new Intl.DateTimeFormat('de', opts); }
  }
  function deliveryRange() {
    var d = A.delivery || { min: 4, max: 8 };
    var lang = A.lang || document.documentElement.lang || 'de';
    // Count weekdays only. Start from tomorrow; skip Saturdays and Sundays.
    // Midday avoids DST boundary issues when advancing across dates.
    function addBusinessDays(start, count) {
      var date = new Date(start.getFullYear(), start.getMonth(), start.getDate(), 12);
      var remaining = Math.max(0, Math.floor(Number(count) || 0));
      while (remaining > 0) {
        date.setDate(date.getDate() + 1);
        if (date.getDay() !== 0 && date.getDay() !== 6) remaining--;
      }
      return date;
    }
    var today = new Date();
    var from = addBusinessDays(today, d.min);
    var to = addBusinessDays(today, d.max);
    var long = makeFormatter(lang, true), short = makeFormatter(lang, false);
    return { from: from, to: to, fromLong: long.format(from), toLong: long.format(to), fromShort: short.format(from), toShort: short.format(to) };
  }

  window.ACPU = { formatMoney: formatMoney, deliveryRange: deliveryRange };
})();

/* ---------- cart page: quantity buttons ---------- */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-cart-qty]').forEach(function (control) {
    var input = control.querySelector('.qty');
    var minus = control.querySelector('[data-cart-minus]');
    var plus = control.querySelector('[data-cart-plus]');
    var key = control.dataset.lineKey;
    if (!input || !minus || !plus || !key) return;
    var busy = false;
    var changeUrl = (window.ACP && ACP.routes && ACP.routes.cartChange) || '/cart/change.js';

    function setQuantity(quantity) {
      if (busy) return;
      busy = true;
      control.classList.add('is-loading');
      minus.disabled = true; plus.disabled = true;
      fetch(changeUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      }).then(function (r) {
        if (!r.ok) throw new Error('Cart update failed');
        window.location.reload();
      }).catch(function () {
        busy = false;
        control.classList.remove('is-loading');
        minus.disabled = false; plus.disabled = false;
      });
    }
    minus.addEventListener('click', function () { setQuantity(Math.max(0, (parseInt(input.value || '0', 10)) - 1)); });
    plus.addEventListener('click', function () { setQuantity((parseInt(input.value || '0', 10)) + 1); });
  });
});

/* ---------- footer legal panels open when linked by hash ---------- */
document.addEventListener('DOMContentLoaded', function () {
  function openFooterLegal(hash) {
    if (!hash) return;
    var el = null;
    try { el = document.querySelector(hash); } catch (e) { return; }
    if (el && el.matches('details.footer-legal-detail')) {
      el.open = true;
      setTimeout(function () { el.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 50);
    }
  }
  document.querySelectorAll('.footer-legal-links a[href^="#"]').forEach(function (link) {
    link.addEventListener('click', function (event) {
      var hash = link.getAttribute('href');
      var el = null;
      try { el = document.querySelector(hash); } catch (e) { return; }
      if (!el) return;
      event.preventDefault();
      history.replaceState(null, '', hash);
      openFooterLegal(hash);
    });
  });
  openFooterLegal(window.location.hash);
});
